import React from 'react';
import { Grid } from '@material-ui/core';
const StepCounter = (props) => {
    const { total, step } = props;
    return (React.createElement(Grid, { container: true, justify: "space-between", style: { margin: '55px 0 25px 0' } }, Array.from({ length: total }).map((_, index) => {
        return (React.createElement("div", { key: index, style: {
                display: 'inline',
                backgroundColor: index === step || (props.colorAll && index < step)
                    ? 'var(--primary)'
                    : 'var(--gray)',
                height: '4px',
                width: `calc((100% - (${total} - 1) * 5px) / ${total})`,
            } }));
    })));
};
export default StepCounter;
